/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.moderation.getSubjects'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  subjects: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), {
    maxLength: 100,
    minLength: 1,
  }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  subjects: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ModerationDefs.SubjectView>(
      (() => ModerationDefs.subjectView) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get details about subjects. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid
